import { loadSmartCaptcha, SMART_CAPTCHA_LOAD_ERROR_TEXT } from '../services/smart-captcha';

/**
 * Состояние загрузки SmartCaptcha для форм (T-17b).
 * captchaLoadError — текст для пользователя; форма показывает его с кнопкой «Повторить загрузку».
 */
export const smartCaptchaMixin = {
    data() {
        return {
            captchaLoadError: '',
        };
    },

    methods: {
        /**
         * @return {Promise<Object|null>} window.smartCaptcha или null, если загрузить не удалось
         */
        ensureSmartCaptcha() {
            this.captchaLoadError = '';

            return loadSmartCaptcha().catch((error) => {
                window.console.warn('[smart-captcha]', error.message);
                this.captchaLoadError = SMART_CAPTCHA_LOAD_ERROR_TEXT;
                return null;
            });
        },
    },
};
